import { render, staticRenderFns } from "./PFSettlementEmployeeDetails.vue?vue&type=template&id=3be24542"
import script from "./PFSettlementEmployeeDetails.vue?vue&type=script&lang=js"
export * from "./PFSettlementEmployeeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports